import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { providerNames } from 'resources/ethereum/providers';
import { pollToRextractBasicInfoFromWeb3 } from 'store/features/ethereum/actions';
import { selectDetectedEthereumProviderName } from 'store/features/ethereum/selectors';

import Web3Facade from 'ethereum/web3-facade';

function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

function mapStateToProps(state) {
  return {
    providerName: selectDetectedEthereumProviderName(state),
  };
}

function canRegisterToPollToRextractBasicInfoFromWeb3(props, context) {
  if (!context || !context.web3) return false;
  if (!props || !props.providerName) return false;
  if (props.providerName !== providerNames.metaMask) return false;
  return true;
}

function registerToPollToRextractBasicInfoFromWeb3(props, context) {
  const pollAction = pollToRextractBasicInfoFromWeb3.register({ web3: context.web3 });
  const pollerId = pollAction.payload.pollerId;
  props.dispatch(pollAction);
  return pollerId;
}

function unregisterToPollToRextractBasicInfoFromWeb3(props, { pollerId }) {
  props.dispatch(pollToRextractBasicInfoFromWeb3.unregister({ pollerId }));
}

export default function injectWeb3(WrappedComponent) {
  class InjectWeb3 extends Component {
    static displayName = `InjectWeb3(${getDisplayName(WrappedComponent)})`;

    static contextTypes = {
      web3: PropTypes.instanceOf(Web3Facade),
    };

    static WrappedComponent = WrappedComponent;

    constructor(props) {
      super(props);

      // Don't use autobind here
      this.unregisterPolling = this.unregisterPolling.bind(this);
      this.registerPolling = this.registerPolling.bind(this);
    }

    unregisterPolling() {
      if (this.basicInfoPollerId) {
        unregisterToPollToRextractBasicInfoFromWeb3(this.props, {
          pollerId: this.basicInfoPollerId,
        });
      }
    }

    registerPolling() {
      if (canRegisterToPollToRextractBasicInfoFromWeb3(this.props, this.context)) {
        this.basicInfoPollerId = registerToPollToRextractBasicInfoFromWeb3(
          this.props,
          this.context
        );
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...{ web3: this.context.web3 }}
          pollerId={this.basicInfoPollerId}
          unregisterPolling={() => this.unregisterPolling()}
          registerPolling={() => this.registerPolling()}
        />
      );
    }

    componentWillUnmount() {
      this.unregisterPolling();
    }
  }

  return connect(mapStateToProps)(InjectWeb3);
}
